export default(function debounce(func, delay) {
  let inDebounce;

  return function () {
    const context = this;
    const args = arguments;

    clearTimeout(inDebounce);

    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/debounce.js